<template>
  <div>
    <!-- Barre supérieure -->
    <div class="top-bar">
      <div class="container top-bar__row">
        <div class="contact-info">
          <span class="address"><i class="fas fa-map-marker-alt"></i> 12 Bd Hassan Al Alaoui Rés. Nissrine – Ain Borja, Casablanca</span>
          <span class="phone"><i class="fas fa-phone"></i> +212 522 600 506 / +212 522 620 507</span>
          <span class="email"><i class="fas fa-envelope"></i> info@supracare.ma</span>
        </div>
        <span class="hours"><i class="fas fa-clock"></i> Lun–Ven 08h30–18h30 · Sam 08h30–12h30</span>
        <div class="social-icons">
          <a href="https://facebook.com" target="_blank" aria-label="Facebook"><i class="fab fa-facebook-f"></i></a>
          <a href="https://twitter.com" target="_blank" aria-label="Twitter"><i class="fab fa-twitter"></i></a>
          <a href="https://linkedin.com" target="_blank" aria-label="LinkedIn"><i class="fab fa-linkedin-in"></i></a>
          <a href="https://instagram.com" target="_blank" aria-label="Instagram"><i class="fab fa-instagram"></i></a>
        </div>
      </div>
    </div>

    <!-- Navigation principale -->
    <nav class="navbar" :class="{'navbar--scrolled': isScrolled}" role="navigation" aria-label="Navigation principale">
      <div class="container navbar__row">
        <div class="logo-container">
          <router-link to="/" aria-label="Accueil">
            <img src="@/assets/logo.png" alt="SupraCare" class="logo-image" />
          </router-link>
        </div>

        <!-- Liens -->
        <ul :class="['nav-links', { 'nav-active': isNavOpen }]">
          <li @click="closeNav"><router-link to="/" exact>Accueil</router-link></li>
          <li class="nav-dropdown">
            <DropdownCertif @navigateToCertification="navigateToCertification" />
          </li>
          <li @click="closeNav"><router-link to="/services">Garantie & Services</router-link></li>
          <li @click="closeNav"><router-link to="/references">Références</router-link></li>
          <li @click="closeNav"><router-link to="/contact">Contact</router-link></li>

          <li class="nav-cta" @click="closeNav">
            <a href="https://shop.supracare.ma/" target="_blank" class="btn-shop">
              <i class="fas fa-shopping-cart"></i><span>Shop</span>
            </a>
          </li>
          <li class="nav-account" @click="closeNav">
            <a href="https://shop.supracare.ma/connexion" target="_blank" title="Mon compte">
              <i class="fas fa-user"></i><span>Mon compte</span>
            </a>
          </li>
        </ul>

        <!-- Bouton burger -->
        <button class="menu-button"
                :aria-expanded="isNavOpen.toString()"
                aria-controls="menu-principal"
                @click="toggleNav">
          <i :class="isNavOpen ? 'fas fa-times' : 'fas fa-bars'"></i>
        </button>
      </div>

      <!-- Backdrop mobile -->
      <div class="nav-backdrop" v-if="isNavOpen" @click="closeNav" aria-hidden="true"></div>
    </nav>

    <!-- WhatsApp FAB -->
    <a href="https://wa.me/+212662297001" target="_blank" class="whatsapp-icon" title="WhatsApp">
      <i class="fab fa-whatsapp"></i>
    </a>
  </div>
</template>

<script>
import DropdownCertif from "@/components/DropdownCertif.vue";

export default {
  name: "NavbarI",
  components: { DropdownCertif },
  data() {
    return {
      isNavOpen: false,
      isScrolled: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.onScroll);
    document.body.classList.remove("no-scroll");
  },
  methods: {
    toggleNav() {
      this.isNavOpen = !this.isNavOpen;
      document.body.classList.toggle("no-scroll", this.isNavOpen);
    },
    closeNav() {
      this.isNavOpen = false;
      document.body.classList.remove("no-scroll");
    },
    onScroll() {
      this.isScrolled = window.scrollY > 8;
    },
    navigateToCertification() {
      this.$router.push("/certification");
      this.closeNav();
    },
  },
};
</script>

<style scoped>
/* ===== Variables */
:root{
  --brand:#00998B;
  --brand-dark:#05305b;
  --ink:#22313a;
  --muted:#6b7a86;
  --surface:#ffffff;
  --bar:#05305b;
}

/* ===== Layout helpers */
.container{ max-width:1200px; margin:0 auto; padding:0 18px; }

/* ===== Top bar */
.top-bar{
  background: var(--bar);
  color:#fff;
  font-size: 13px;
  border-bottom: 1px solid rgba(255,255,255,.12);
}
.top-bar__row{
  display:flex; align-items:center; gap:12px; padding:8px 0;
}
.contact-info{ display:flex; flex-wrap:wrap; gap:14px; }
.contact-info i{ margin-right:6px; }
.hours{ opacity:.95; white-space:nowrap; }
.social-icons{ margin-left:auto; display:flex; gap:10px; }
.social-icons a{ color:#e8f5f5; transition:opacity .2s ease, transform .15s ease; }
.social-icons a:hover{ opacity:1; transform:translateY(-1px); }

/* ===== Navbar */
.navbar{
  position: sticky; top:0; left:0; z-index:1000;
  background:#fff;
  transition: box-shadow .2s ease, background .2s ease, border-color .2s ease;
  border-bottom:1px solid rgba(0,0,0,.06);
}
.navbar--scrolled{
  box-shadow: 0 10px 28px rgba(0,0,0,.08);
  background:#fff;
}
.navbar__row{
  display:flex; align-items:center; justify-content:space-between; gap:16px; min-height:72px;
}
.logo-container{ display:flex; align-items:center; }
.logo-image{ height:72px; width:auto; display:block; }

/* Links */
.nav-links{
  list-style:none; display:flex; align-items:center; gap:26px; margin:0;
}
.nav-links a{
  color:var(--ink); text-decoration:none; font-size:15px; font-weight:600; letter-spacing:.01em;
  position:relative; padding:8px 2px; display:inline-flex; align-items:center; gap:8px;
}
.nav-links a::after{
  content:""; position:absolute; left:0; bottom:0; height:2px; width:0%;
  background: var(--brand); transition: width .22s ease;
}
.nav-links a:hover::after,
.nav-links a.router-link-exact-active::after{ width:100%; }
.nav-links a.router-link-exact-active{ color: var(--brand-dark); }

/* CTA Shop & Compte */
.nav-cta .btn-shop{
  display:inline-flex; align-items:center; gap:8px;
  background: linear-gradient(180deg, var(--brand), #028c7f);
  color:#fff; padding:10px 14px; border-radius:12px; font-weight:800;
  box-shadow:0 10px 22px rgba(0,153,139,.2);
  transition: transform .15s ease, box-shadow .2s ease, filter .2s ease;
}
.nav-cta .btn-shop:hover{ transform:translateY(-1px); box-shadow:0 14px 28px rgba(0,153,139,.28); filter:brightness(1.03); }
.nav-account a{ color:var(--brand-dark); font-weight:700; }

/* Burger */
.menu-button{
  display:none; background:transparent; border:0; font-size:26px; padding:8px; color:var(--ink); cursor:pointer;
}

/* Drawer mobile */
.nav-backdrop{
  position:fixed; inset:0; background:rgba(0,0,0,.35);
  backdrop-filter: blur(2px);
}
.no-scroll{ overflow:hidden; } /* body lock */

@media (max-width: 1040px){
  .top-bar{ display:none; }
  .menu-button{ display:block; }
  .logo-image{ height:58px; }

  .nav-links{
    position: fixed; top:0; right:0; height:100vh; width:min(78vw, 360px);
    background:#fff; flex-direction:column; align-items:flex-start;
    padding:84px 18px 18px; gap:16px; margin:0;
    box-shadow: -12px 0 28px rgba(0,0,0,.12);
    transform: translateX(100%); transition: transform .25s ease;
  }
  .nav-active{ transform: translateX(0%); }
  .nav-links li{ width:100%; }
  .nav-links a{ width:100%; padding:12px 6px; }
  .nav-cta, .nav-account a{ width:100%; }
  .nav-cta .btn-shop{ width:100%; justify-content:center; }
}

/* WhatsApp FAB */
.whatsapp-icon{
  position:fixed; bottom:20px; right:20px; z-index:1001;
  width:52px; height:52px; display:grid; place-items:center;
  background:#25D366; color:#fff; border-radius:999px; font-size:26px;
  box-shadow:0 12px 26px rgba(0,0,0,.2); transition: transform .15s ease, filter .2s ease;
}
.whatsapp-icon:hover{ transform:translateY(-2px); filter:brightness(1.05); }

/* Focus visible (a11y) */
:focus-visible{
  outline: 3px solid rgba(0,153,139,.25);
  outline-offset: 2px;
}

/* Dark mode */
@media (prefers-color-scheme: dark){
  .top-bar{ background:#08263a; border-bottom-color: rgba(255,255,255,.08); }
  .navbar{ background:#0f1720; border-bottom-color: rgba(255,255,255,.06); }
  .navbar--scrolled{ box-shadow: 0 12px 32px rgba(0,0,0,.5); }
  .nav-links a{ color:#e6edf1; }
  .nav-links a::after{ background:#73d8cf; }
  .nav-links a.router-link-exact-active{ color:#a5f3ee; }
  .nav-links{ background:#0f1720; }
  .nav-backdrop{ background:rgba(0,0,0,.5); }
  .nav-cta .btn-shop{ box-shadow: 0 10px 24px rgba(0,0,0,.45); }
}


/* === Fix LIGHT MODE ===*/

/* 1) Drawer mobile  */
@media (max-width: 1040px){
  .nav-links{
    background:#fff !important;      /* sinon transparent = invisible */
    z-index: 1001 !important;         /* au-dessus du backdrop */
  }
  .nav-backdrop{ z-index: 1000 !important; }
  .menu-button{ z-index: 1002 !important; color:#05305b !important; }
}

/* 2) Bouton Shop : force le dégradé et le texte blanc en mode clair */
.nav-cta .btn-shop{
  background: linear-gradient(180deg,#00998B,#028c7f) !important;
  color:#fff !important;
  border: 0 !important;
  box-shadow: 0 10px 22px rgba(0,153,139,.20) !important;
}

/* Annule toute règle qui blanchit les <a> dans la nav */
.nav-links a{ background: transparent !important; }

/* Option: au survol, conserve bien le dégradé du Shop */
.nav-cta .btn-shop:hover{
  filter: brightness(1.05) !important;
  box-shadow: 0 14px 28px rgba(0,153,139,.28) !important;
}
/* ====== SIDEBAR (drawer) PRO – Mobile & Tablette ====== */
@media (max-width: 1040px){
  /* Bouton burger au-dessus de tout */
  .menu-button{
    display:block !important;
    z-index:1002 !important;
    color:#05305b !important;
  }

  /* Panneau latéral (ton <ul class="nav-links">) */
  .nav-links{
    position: fixed;
    top: 0; right: 0;
    height: 100dvh;              /* prend toute la hauteur écran */
    width: min(82vw, 360px);     /* largeur élégante */
    background: #fff;
    border-left: 1px solid rgba(0,0,0,.08);
    box-shadow: -18px 0 40px rgba(0,0,0,.18);
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    padding: calc(env(safe-area-inset-top) + 76px) 18px 18px; /* espace sous le header */
    transform: translateX(100%);
    transition: transform .28s cubic-bezier(.22,.61,.36,1);
    z-index: 1001;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .nav-active{ transform: translateX(0%); }

  /* Liens dans la sidebar */
  .nav-links li{ width: 100%; }
  .nav-links a{
    display:flex; align-items:center; gap:10px;
    width:100%;
    padding:12px 10px;
    border-radius:12px;
    font-weight:700;
    color:#0f1720;
    text-decoration:none;
    transition: background .15s ease, color .15s ease, transform .15s ease;
  }
  .nav-links a:hover{ background:#f4f7f8; }
  .nav-links a.router-link-exact-active{
    background:#eefbf9; color:#05305b;
  }

  /* CTA Shop joli et bien visible dans la sidebar */
  .nav-cta .btn-shop{
    display:flex; justify-content:center; align-items:center; gap:8px;
    width:100%;
    background: linear-gradient(180deg,#00998B,#028c7f);
    color:#fff; padding:12px 14px; border-radius:12px;
    box-shadow: 0 10px 22px rgba(0,153,139,.2);
  }
  .nav-cta .btn-shop:hover{ filter:brightness(1.05); }

  /* Lien "Mon compte" cohérent */
  .nav-account a{
    color:#05305b; font-weight:800; padding:12px 10px;
  }

  /* Backdrop derrière le drawer */
  .nav-backdrop{
    position: fixed; inset: 0;
    background: rgba(0,0,0,.35);
    backdrop-filter: blur(2px);
    z-index: 1000;
  }

  /* Verrouille le scroll quand le menu est ouvert (classe ajoutée au body en JS) */
  .no-scroll{ overflow: hidden; }
}

/* ====== Dark mode de la sidebar ====== */
@media (prefers-color-scheme: dark) and (max-width:1040px){
  .nav-links{
    background:#0f1720; border-left-color: rgba(255,255,255,.06);
    box-shadow: -18px 0 44px rgba(0,0,0,.5);
  }
  .nav-links a{ color:#e6edf1; }
  .nav-links a:hover{ background:#142231; }
  .nav-links a.router-link-exact-active{ background:#0b1e2a; color:#a5f3ee; }
  .nav-cta .btn-shop{ box-shadow: 0 10px 24px rgba(0,0,0,.45); }
  .nav-backdrop{ background: rgba(0,0,0,.5); }
}

/* =================== MODE SOMBRE AUTO (selon l’OS) =================== */
@media (prefers-color-scheme: dark){
  /* Top bar */
  .top-bar{
    background:#0b1e2a !important;
    color:#e6edf1 !important;
    border-bottom:1px solid rgba(255,255,255,.08) !important;
  }
  .social-icons a{ color:#cfe9ea !important; }
  .social-icons a:hover{ color:#ffffff !important; }

  /* Navbar */
  .navbar{
    background:#0f1720 !important;
    color:#e6edf1 !important;
    border-bottom:1px solid rgba(255,255,255,.06) !important;
  }
  .navbar--scrolled{ box-shadow: 0 12px 32px rgba(0,0,0,.55) !important; }

  .logo-image{ filter:none; } /* garde ton logo net */

  /* Liens */
  .nav-links a{
    color:#e6edf1 !important;
    background: transparent !important;
  }
  .nav-links a::after{ background:#73d8cf !important; }
  .nav-links a.router-link-exact-active{
    color:#a5f3ee !important;
  }

  /* CTA Shop + Compte */
  .nav-cta .btn-shop{
    background: linear-gradient(180deg,#00a897,#00998B) !important;
    color:#fff !important;
    box-shadow: 0 10px 24px rgba(0,0,0,.45) !important;
  }
  .nav-account a{ color:#cfe9ea !important; }

  /* Burger + backdrop */
  .menu-button{ color:#e6edf1 !important; }
  .nav-backdrop{
    background: rgba(0,0,0,.55) !important;
    backdrop-filter: blur(2px);
  }

  /* WhatsApp FAB (inchangé, mais un peu plus pop en sombre) */
  .whatsapp-icon{ box-shadow:0 12px 26px rgba(0,0,0,.5) !important; }
}

/* =============== MODE SOMBRE pour la SIDEBAR (mobile/tablette) =============== */
@media (prefers-color-scheme: dark) and (max-width:1040px){
  .nav-links{
    background:#0f1720 !important;
    border-left:1px solid rgba(255,255,255,.06) !important;
    box-shadow: -18px 0 44px rgba(0,0,0,.6) !important;
  }
  .nav-links a{ color:#e6edf1 !important; }
  .nav-links a:hover{ background:#142231 !important; }
  .nav-links a.router-link-exact-active{
    background:#0b1e2a !important;
    color:#a5f3ee !important;
  }
}

/* ===== Top-bar visible en mode clair (desktop) ===== */
.top-bar{
  display: flex !important;           
  position: relative;
  z-index: 1001;                       
  background: #05305b !important;
  color: #fff !important;
}

/* On la cache seulement en petit écran */
@media (max-width: 1040px){
  .top-bar{ display: none !important; }
}


.navbar{
  position: sticky;                    /* reste en haut au scroll */
  top: 0;
  z-index: 1000;                       /* légèrement sous la top-bar */
  background: #fff;
}



/* Transition & blur actifs en permanence */
.navbar{
  animation: navEnter .35s ease-out both;
  transition:
    background .25s ease,
    border-color .25s ease,
    box-shadow .25s ease,
    -webkit-backdrop-filter .25s ease,
    backdrop-filter .25s ease,
    transform .2s ease !important;
  -webkit-backdrop-filter: saturate(1.05) blur(0px) !important;
  backdrop-filter: saturate(1.05) blur(0px) !important;
}

/* État scrolé : blur fort + ombre forte (comme sombre) */
.navbar--scrolled{
  background: rgba(255,255,255,.88) !important;          /* clair mais translucide */
  border-bottom-color: rgba(0,0,0,.06) !important;
  box-shadow: 0 12px 32px rgba(0,0,0,.55) !important;     /* même intensité que sombre */
  -webkit-backdrop-filter: saturate(1.35) blur(10px) !important;
  backdrop-filter: saturate(1.35) blur(10px) !important;
  transform: translateZ(0);
}

/* Shrink du logo au scroll (identique au sombre) */
.logo-image{ transition: height .25s ease, transform .25s ease, filter .25s ease !important; }
.navbar--scrolled .logo-image{ height: 60px !important; transform: translateY(-1px) !important; }

/* Liens : halo + soulignement animé (même ressenti) */
.nav-links a{
  position: relative; overflow: hidden; transition: color .15s ease;
}
.nav-links a::before{
  content:""; position:absolute; inset:auto auto 0 50%;
  width:12px; height:12px; border-radius:999px; pointer-events:none;
  background: radial-gradient(closest-side, rgba(0,153,139,.22), transparent 70%);
  transform: translateX(-50%) scale(0); opacity:0;
  transition: transform .25s ease, opacity .25s ease;
}
.nav-links a:hover::before{ transform: translateX(-50%) scale(10); opacity:.8; }

/* Drawer mobile : mêmes transitions “smooth” */
@media (max-width:1040px){
  .nav-links{
    transition: transform .28s cubic-bezier(.22,.61,.36,1), background .25s ease, box-shadow .25s ease !important;
  }
  .nav-active{
    background:#fff !important;
    box-shadow:-18px 0 40px rgba(0,0,0,.18) !important;
  }
}

/* Petite anim d’entrée */
@keyframes navEnter{ from{opacity:0; transform:translateY(-6px)} to{opacity:1; transform:translateY(0)} }



</style>

